
import { defineComponent, ref, onMounted, computed } from 'vue';
import { pick } from 'lodash-es';
import type { ElForm } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import RichEditor from './components/rich-editor.vue';
import {
  getWebUserAgreementAgreementIdApi,
  putWebUserAgreementUpdateApi,
  postWebUserAgreementSaveApi,
} from '@/api/agreement';

export default defineComponent({
  components: {
    RichEditor,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const formData = ref({
      title: '',
      typeName: '',
      type: '',
      content: '',
    });
    const formRef = ref<InstanceType<typeof ElForm>>();

    const agreementId = computed(() => {
      return route.query.id as string | void;
    });

    const handleGetDetail = async () => {
      if (agreementId.value) {
        const { data } = await getWebUserAgreementAgreementIdApi(agreementId.value);
        formData.value = pick(data, Object.keys(formData.value)) as any;
      }
    };

    const formRules = {
      title: [{ required: true, message: '请输入协议标题', trigger: ['blur', 'change'] }],
      content: [{ required: true, message: '请输入协议内容', trigger: ['blur', 'change'] }],
      typeName: [{ required: true, message: '请输入协议类型名称', trigger: ['blur', 'change'] }],
      type: [{ required: true, message: '请输入协议类型', trigger: ['blur', 'change'] }],
    };

    const useGoBack = () => {
      router.back();
    };

    const handleSubmit = async () => {
      await formRef.value!.validate();

      if (agreementId.value) {
        await putWebUserAgreementUpdateApi({
          ...formData.value,
          agreementId: agreementId.value,
        });
      } else {
        await postWebUserAgreementSaveApi({
          ...formData.value,
        });
      }

      useGoBack();
    };

    onMounted(() => {
      handleGetDetail();
    });

    return {
      handleSubmit,
      useGoBack,
      formRules,
      formData,
      formRef,
    };
  },
});
